import { render, staticRenderFns } from "./CommissionDetails.vue?vue&type=template&id=52a5176b&scoped=true"
import script from "./CommissionDetails.vue?vue&type=script&lang=js"
export * from "./CommissionDetails.vue?vue&type=script&lang=js"
import style0 from "./CommissionDetails.vue?vue&type=style&index=0&id=52a5176b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5176b",
  null
  
)

export default component.exports